import * as CL from '@design-system/component-library';
import { Modal } from '../Modal/Modal';
import { dsClass } from '../../common/constants/dsClasses';
import { t } from '../../common/i18n';
import { useAuth } from '../../public/site/AuthProvider';

export const ElisaIdLoginDialog = () => {
  const { prepareElisaIdLogin } = useAuth();

  return (
    <Modal closeable={false} onClose={() => {}} align="center" size="m">
      <div className={`${dsClass.DISPLAY_FLEX} ${dsClass.JUSTIFY_CONTENT_CENTER}`}>
        <CL.Logo></CL.Logo>
      </div>
      <div>
        <h3>{t.DZQF('New login')}</h3>
        <p>{t.F54R('A new login, personal Elisa ID, will be taken into use in OmaElisa for Companies.')}</p>
        <p className={dsClass.FONT_WEIGHT_BOLD}>{t.RXRO('This is a test-environment for the new Elisa ID.')}</p>
      </div>
      <div className={`${dsClass.DISPLAY_FLEX} ${dsClass.JUSTIFY_CONTENT_CENTER}`}>
        <CL.Button
          color="primary"
          id="proceed-to-new-login-btn"
          size="l"
          style={{ width: '100%' }}
          onClick={() => prepareElisaIdLogin()}
          type="button"
        >
          {t.M76W('Log in with Elisa ID')}
        </CL.Button>
      </div>
    </Modal>
  );
};
